// What KIND of trail it is and what a visitor will FIND on it — the two
// lists a trail is described in on the website's Trails page. Set on the
// trail form, read by the Types of trail and Features and challenges
// blocks. Descriptions are defaults; each block can reword them.
//
// Twin of App\Support\Trails\TrailCatalog; sitetrailspage_verify
// compares the two key by key.

export const TRAIL_TYPES = [
    { key: 'singletrack', label: 'Singletrack', description: 'Narrow trail one rider or hiker wide. Natural tread that follows the land, with roots, rock and tight turns.' },
    { key: 'doubletrack', label: 'Doubletrack', description: 'Two-track or old road width. Room to ride side by side, usually with gentle grades.' },
    { key: 'flow', label: 'Flow trail', description: 'Bike-optimized trail with berms, rollers and jumps built so you can carry speed with little pedaling or braking.' },
    { key: 'technical', label: 'Technical trail', description: 'Rock, roots, drops and steep pitches that reward skill. Expect to walk sections the first time.' },
    { key: 'jump_line', label: 'Jump line', description: 'A run of built jumps, from rollers and tabletops to gaps, meant to be ridden in sequence.' },
    { key: 'pump_track', label: 'Pump track', description: 'A loop of rollers and berms you ride by pumping, not pedaling. Good for every age and skill.' },
    { key: 'multi_use', label: 'Multi-use path', description: 'Wider, smoother trail shared by hikers, bikes and often horses. Good for families and first outings.' },
    { key: 'paved', label: 'Paved path', description: 'Hard-surfaced path suited to strollers, wheelchairs and road bikes.' },
    { key: 'adaptive', label: 'Adaptive trail', description: 'Built for adaptive bikes and mobility devices: wide tread, gentle grades and passable features.' },
    { key: 'connector', label: 'Connector', description: 'A short link between trails, trailheads or town.' },
    { key: 'nordic', label: 'Nordic ski trail', description: 'Groomed classic and skate track in winter.' },
    { key: 'snowshoe', label: 'Snowshoe trail', description: 'Packed or marked routes for snowshoeing.' },
];

export const TRAIL_FEATURES = [
    { key: 'rock_gardens', label: 'Rock gardens', description: 'Embedded rock sections that need line choice' },
    { key: 'roots', label: 'Roots', description: 'Exposed roots, slick when wet' },
    { key: 'rock_rolls', label: 'Rock rolls', description: 'Steep rock faces you roll down rather than drop off' },
    { key: 'berms_jumps', label: 'Berms and jumps', description: 'Banked turns, rollers and tabletops' },
    { key: 'drops', label: 'Drops', description: 'Ledges and drops, with or without a ride-around' },
    { key: 'skinny_bridges', label: 'Skinny bridges', description: 'Narrow raised boardwalks and ladder bridges' },
    { key: 'steep_climbs', label: 'Steep climbs', description: 'Sustained grades above 10%' },
    { key: 'steep_downhill', label: 'Steep downhill', description: 'Long, steep descents that need control' },
    { key: 'switchbacks', label: 'Switchbacks', description: 'Tight climbing and descending turns' },
    { key: 'creek_crossings', label: 'Creek crossings', description: 'Fords and wet-season water' },
    { key: 'bridges', label: 'Bridges', description: 'Bridges over creeks, gullies and wet ground' },
    { key: 'exposure', label: 'Exposure', description: 'Narrow tread with drop-offs' },
    { key: 'viewpoints', label: 'Scenic viewpoints', description: 'Overlooks worth stopping for' },
    { key: 'shade', label: 'Shade', description: 'Tree cover for hot days' },
    { key: 'groomed_snow', label: 'Groomed snow', description: 'Set track and packed snowshoe routes' },
];

// Derived from the trail's uses (equestrian), never ticked.
export const HORSE_FEATURE = { key: 'horse_access', label: 'Horse access', description: 'Trails open to equestrians' };

const TYPE_BY_KEY = Object.fromEntries(TRAIL_TYPES.map((t) => [t.key, t]));
const FEATURE_BY_KEY = Object.fromEntries([...TRAIL_FEATURES, HORSE_FEATURE].map((f) => [f.key, f]));

export function trailType(key) {
    return TYPE_BY_KEY[key] || null;
}

export function trailFeature(key) {
    return FEATURE_BY_KEY[key] || null;
}

/** Every feature a Trails page can show, in table order. */
export const ALL_FEATURES = [...TRAIL_FEATURES, HORSE_FEATURE];
